/* Doodle Dreams – sticky variant select linked to the real Starter form.
 * Multi-item Duo/Special remain controlled by their own selectors above. */
(function(){
  if(window.__ddStickyATCReady) return;
  window.__ddStickyATCReady=true;
  function init(root){
    (root||document).querySelectorAll('.dd-sticky-atc[data-dd-sticky-section]').forEach(function(bar){
      if(bar.dataset.ddStickyBound==='true')return;
      bar.dataset.ddStickyBound='true';
      var section=bar.getAttribute('data-dd-sticky-section');
      var picker=bar.querySelector('[data-dd-sticky-variant-selector]');
      if(!picker)return;
      var info=document.getElementById('ProductInfo-'+section);
      if(!info)return;
      var starter=info.querySelector('.dd-bundle-options #quantity1');
      picker.addEventListener('change',function(){
        // Sticky selection stays independent of the Starter/Duo/Special cards.
        // It must not change the active offer or its marker add-on choices.
        var notice=bar.querySelector('.dd-sticky-choice-message');
        if(notice)notice.hidden=true;
        var chosen=picker.options[picker.selectedIndex];
        var image=bar.querySelector('.dd-sticky-atc__image');
        if(image&&chosen&&chosen.dataset.ddPicture)image.src=chosen.dataset.ddPicture;
      });
      // Keep this control in step with a design chosen in the regular Starter card.
      // Top gallery style pills do not count as a bundle design selection.
      info.addEventListener('change',function(event){
        if(event.target.matches('#option-1-variant-'+section+' select.dd-style-dropdown') && starter?.checked){
          picker.value=event.target.value;
          var chosen=picker.options[picker.selectedIndex];
          var image=bar.querySelector('.dd-sticky-atc__image');
          if(image&&chosen?.dataset.ddPicture)image.src=chosen.dataset.ddPicture;
        }
      });
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){init(document)});
  else init(document);
  document.addEventListener('shopify:section:load',function(e){init(e.target)});
})();
